import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import {
  Attribute,
  CSSClass,
  DataTransferType,
  DndEvent,
} from './dom.constant';

@Directive({
  selector: '[akDashboardNode]',
})
export class DashboardNodeDirective implements OnInit {
  @Output() dragStart: EventEmitter<void>;
  @Output() dragEnd: EventEmitter<void>;
  @Input() active: boolean;
  @Input() data: any;

  constructor(private renderer: Renderer2, private el: ElementRef) {
    this.dragStart = new EventEmitter();
    this.dragEnd = new EventEmitter();
    this.active = true;
  }

  ngOnInit(): void {
    if (this.active && this.data) {
      this.renderer.setAttribute(
        this.el.nativeElement,
        Attribute.DRAGGABLE,
        'true'
      );
    }
  }

  @HostListener('dragstart', ['$event'])
  sendDragStartEvent($event: DndEvent): void {
    $event.stopPropagation();
    $event.dataTransfer.setData(
      DataTransferType.TEXT,
      JSON.stringify(this.data)
    );

    this.renderer.addClass(this.el.nativeElement, CSSClass.DRAGGING);
    this.dragStart.emit();
  }

  @HostListener('dragend', ['$event'])
  sendDragEndEvent($event: DragEvent): void {
    $event.stopPropagation();
    this.renderer.removeClass(this.el.nativeElement, CSSClass.DRAGGING);
    this.dragEnd.emit();
  }
}
